module.exports = __webpack_public_path__ + "01ad819fd86ea2adf5ac757c1d7ed41a.mp3"


/*****************
 ** WEBPACK FOOTER
 ** ./src/audio/OAM_2.mp3
 ** module id = 170
 ** module chunks = 0
 **/